module.exports = __webpack_public_path__ + "7a2c7b2f968bdd0a3a388e4a0ba60a0e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-3-s.png
// module id = 2704
// module chunks = 0